import { render } from "./DecksV2.vue?vue&type=template&id=504a5471&scoped=true"
import script from "./DecksV2.vue?vue&type=script&lang=js"
export * from "./DecksV2.vue?vue&type=script&lang=js"

import "./DecksV2.vue?vue&type=style&index=0&id=504a5471&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504a5471"]])

export default __exports__